import React from "react";
import { SidebarContext } from "./sidebarContext";
import { useAuth } from "../Services/auth";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import TendersClubLogo from "../Components/tendersClubLogo";
import { mdiMenu, mdiFullscreen } from "@mdi/js";
import { useComponentsStore } from "../Stores/componentsStore";
import devDebug from "../Helpers/debug";
import Navigation from "./nav/navigation";
import LanguageDropdown from "./nav/languageDropdown";
import DarkmodeToggle from "./nav/darkModeToggle";
import ProfileDropdown from "./nav/profileDropdown";
import AwardsSearchDropdown from "./nav/awardsSearchDropdown";
import { useAuthStore } from "../Stores/authStore";
import { useNavigate } from "react-router-dom";
import RefreshNotification from "./refreshOnVersionChange/refreshNotification";

export default function Header({ location }) {
  const navigate = useNavigate();
  const [
    setShowUnsavedPopup,
    showUnsavedPopup,
    setAwardsDropDownOpen,
    isDark,
    showRefreshWarningWithLogout,
    showRefreshWarningWithoutLogout,
  ] = useComponentsStore((state) => [
    state.setShowUnsavedPopup,
    state.showUnsavedPopup,
    state.setAwardsDropDownOpen,
    state.isDark,
    state.showRefreshWarningWithLogout,
    state.showRefreshWarningWithoutLogout,
  ]);
  const [menu, setMenu] = React.useState(false);
  let auth = useAuth();
  let authenticated = false;
  if (useAuthStore.getState()?.user?.email) {
    authenticated = true;
  }
  const subscription = useAuthStore.getState()?.user?.subscription;
  let daysLeft = 0;
  if (subscription) {
    daysLeft = dayjs(subscription.subscription_period_end).diff(dayjs(), "day");
  }
  const ctx = React.useContext(SidebarContext);

  const specialToggleMenu = () => {
    setAwardsDropDownOpen(false);
    ctx.toggleMenu(true);
    let isActive = false;
    if (typeof document?.getElementsByClassName("mobile-sidebar-nested-dropdown")?.[0] !== "undefined") {
      for (let item of document
        ?.getElementsByClassName("mobile-sidebar-nested-dropdown")?.[0]
        ?.getElementsByClassName("nested-mobile-menu-item")) {
        if (item.classList.contains("active")) {
          isActive = true;
        }
      }
      if (isActive) {
        window.setTimeout(() => {
          devDebug("setting awards dropdown to open");
          setAwardsDropDownOpen(true);
        }, 400);
      }
    }
  };

  const { t } = useTranslation();
  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  React.useEffect(() => {
    setTimeout(() => {
      let themeLink = document.getElementById("app-theme");
      if (isDark) {
        themeLink.href = `${window.location.origin}/lara-dark-purple/theme.css`;
      } else {
        themeLink.href = `${window.location.origin}/lara-light-purple/theme.css`;
      }
    }, 500);
  }, [isDark]);

  return (
    <header
      id="page-topbar"
      className={`${
        (!useAuthStore.getState()?.user?.email && window.location.pathname === `/${i18n.language.slice(0, 2)}/`) ||
        window.location.pathname.includes("/services")
          ? "page-topbar-transparent"
          : ""
      } ${
        window.location.pathname.includes("/services") ? "services" : ""
      } d-flex align-items-center justify-content-between  `}
    >
      <div className="d-flex flex-column w-full ">
        <div className="d-flex p-1 p-md-2 justify-content-between">
          <div
            className={`${
              window.location.pathname === "/services" ? "services" : ""
            } tc-horizontal-nav-logo-width cursor-pointer`}
            onClick={() => navigate(`/${i18n.language.slice(0, 2)}/`)}
          >
            {(!useAuthStore.getState()?.user?.email && window.location.pathname === `/${i18n.language.slice(0, 2)}/`) ||
            window.location.pathname.includes("/services") ? (
              <TendersClubLogo
                size="normal"
                colour={window.location.pathname.includes("/services") ? "dark" : "light"}
              />
            ) : (
              <TendersClubLogo size="normal" colour={isDark ? "light" : "dark"} />
            )}
          </div>
          <Navigation sidebar={false} />
          <div className="me-auto tc-horizontal-nav-item-colours hide-horizontal-nav">
            {authenticated && !window.location.pathname.includes("/services") ? (
              <AwardsSearchDropdown sidebar={false} ctx={ctx} />
            ) : null}
          </div>
          <div className="d-flex align-items-center justify-content-between tc-nav-flex-gap">
            <DarkmodeToggle />
            <LanguageDropdown />
            <Icon
              onClick={() => {
                toggleFullscreen();
              }}
              path={mdiFullscreen}
              className="tc-full-screen-btn d-xl-inline-block cursor-pointer tc-fullscreen-margin-compensator"
              title={t("Toggle Full Screen")}
              size={1}
              color={isDark ? "#f6f6f6" : "#555b6d"}
            />
            {authenticated ? (
              <ProfileDropdown
                auth={auth}
                isDark={isDark}
                setMenu={setMenu}
                menu={menu}
                setShowUnsavedPopup={setShowUnsavedPopup}
                showUnsavedPopup={showUnsavedPopup}
              />
            ) : null}
            <Icon
              onClick={() => specialToggleMenu()}
              path={mdiMenu}
              className="cursor-pointer tc-toggle-sidebar-btn"
              title={t("Menu")}
              size={1.6}
              color={isDark ? "#f6f6f6" : "#555b6d"}
            />
          </div>
        </div>

        {subscription?.status === "trialing" ? (
          <div className="trial_notification">
            {daysLeft > 0 ? t("This is a trial account. Days Left: ") + daysLeft + ". " : t("Your trial has expired")}
            <Link to={`/${i18n.language.slice(0, 2)}/pricing`}>{t("Subscribe now")}</Link>
          </div>
        ) : null}

        {showRefreshWarningWithLogout || showRefreshWarningWithoutLogout ? <RefreshNotification /> : null}
      </div>
    </header>
  );
}
